module.exports = __webpack_public_path__ + "img/notification-active.50043282.svg";